import { render, staticRenderFns } from "./add_advise.vue?vue&type=template&id=2f642690&scoped=true&"
import script from "./add_advise.vue?vue&type=script&lang=js&"
export * from "./add_advise.vue?vue&type=script&lang=js&"
import style0 from "./add_advise.vue?vue&type=style&index=0&id=2f642690&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f642690",
  null
  
)

export default component.exports